/**
 * Schoolvakanties (regio Zuid) + reken-helpers.
 *
 * Losse data-module: bepaalt of een ISO-week (deels) binnen een schoolvakantie valt.
 * Deze stap koppelt NIETS aan engine/store — puur een seed + helpers, geen gedragswijziging.
 *
 * Hergebruikt de van-tot-overlap-logica van afwezigheid.js (berekenAfwezigheidDagen),
 * die zelf weekNaarMaandag gebruikt → geen duplicatie van de datum-rekenkern.
 */
import { berekenAfwezigheidDagen, ALLE_DAGEN } from './afwezigheid.js';

/**
 * Seed: schoolvakanties regio Zuid.
 *   vast: true  = wettelijk vastgesteld (niet wijzigen)
 *   vast: false = adviesdata; teamleider mag corrigeren
 */
export const SCHOOLVAKANTIES_ZUID = [
  { id: 'zomer-2026',    naam: 'Zomervakantie 2026',      vanDatum: '2026-07-11', totDatum: '2026-08-23', vast: true },
  { id: 'herfst-2026',   naam: 'Herfstvakantie 2026',     vanDatum: '2026-10-17', totDatum: '2026-10-25', vast: false },
  { id: 'kerst-2026',    naam: 'Kerstvakantie 2026-2027', vanDatum: '2026-12-19', totDatum: '2027-01-03', vast: true },
  { id: 'voorjaar-2027', naam: 'Voorjaarsvakantie 2027',  vanDatum: '2027-02-13', totDatum: '2027-02-21', vast: false },
  // TODO: Meivakantie 2027 — exacte data nog te bevestigen, bewust nog niet opgenomen.
  { id: 'zomer-2027',    naam: 'Zomervakantie 2027',      vanDatum: '2027-07-24', totDatum: '2027-09-05', vast: true },
];

/**
 * Geeft de dagen (['ma','di',...]) van week (weeknummer, jaar) die binnen een
 * vakantieperiode vallen. Unie over alle periodes, deterministisch gesorteerd op
 * weekvolgorde (ma→zo). Per periode hergebruikt het de van-tot-overlap van
 * berekenAfwezigheidDagen (zelfde aanpak als de afwezigheidsmap).
 */
export function vakantieDagenInWeek(weeknummer, jaar, periodes = SCHOOLVAKANTIES_ZUID) {
  const gevonden = new Set();
  for (const p of periodes) {
    for (const dag of berekenAfwezigheidDagen(p.vanDatum, p.totDatum, weeknummer, jaar)) {
      gevonden.add(dag);
    }
  }
  return ALLE_DAGEN.filter((d) => gevonden.has(d));
}

/**
 * True als minstens één dag van week (weeknummer, jaar) binnen een vakantieperiode valt.
 */
export function valtWeekInVakantie(weeknummer, jaar, periodes = SCHOOLVAKANTIES_ZUID) {
  return vakantieDagenInWeek(weeknummer, jaar, periodes).length > 0;
}
